"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSingleCardActivityStyle;

function createSingleCardActivityStyle(_ref) {
  var bubbleMaxWidth = _ref.bubbleMaxWidth,
      bubbleMinWidth = _ref.bubbleMinWidth,
      paddingRegular = _ref.paddingRegular;
  return {
    '& > .bubble-box': {
      maxWidth: bubbleMaxWidth,
      minWidth: bubbleMinWidth
    },
    '& > .filler': {
      minWidth: paddingRegular
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVTaW5nbGVDYXJkQWN0aXZpdHlTdHlsZSIsImJ1YmJsZU1heFdpZHRoIiwiYnViYmxlTWluV2lkdGgiLCJwYWRkaW5nUmVndWxhciIsIm1heFdpZHRoIiwibWluV2lkdGgiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvU2luZ2xlQXR0YWNobWVudEFjdGl2aXR5LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVNpbmdsZUNhcmRBY3Rpdml0eVN0eWxlKHtcbiAgYnViYmxlTWF4V2lkdGgsXG4gIGJ1YmJsZU1pbldpZHRoLFxuICBwYWRkaW5nUmVndWxhclxufTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgJyYgPiAuYnViYmxlLWJveCc6IHtcbiAgICAgIG1heFdpZHRoOiBidWJibGVNYXhXaWR0aCxcbiAgICAgIG1pbldpZHRoOiBidWJibGVNaW5XaWR0aFxuICAgIH0sXG5cbiAgICAnJiA+IC5maWxsZXInOiB7XG4gICAgICBtaW5XaWR0aDogcGFkZGluZ1JlZ3VsYXJcbiAgICB9XG4gIH07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFZSxTQUFTQSw2QkFBVCxPQUlRO0VBQUEsSUFIckJDLGNBR3FCLFFBSHJCQSxjQUdxQjtFQUFBLElBRnJCQyxjQUVxQixRQUZyQkEsY0FFcUI7RUFBQSxJQURyQkMsY0FDcUIsUUFEckJBLGNBQ3FCO0VBQ3JCLE9BQU87SUFDTCxtQkFBbUI7TUFDakJDLFFBQVEsRUFBRUgsY0FETztNQUVqQkksUUFBUSxFQUFFSDtJQUZPLENBRGQ7SUFNTCxlQUFlO01BQ2JHLFFBQVEsRUFBRUY7SUFERztFQU5WLENBQVA7QUFVRCJ9